module.exports = __webpack_public_path__ + "static/media/challenge-3.c0dc166f.png";